import React from 'react';

function DomainRouter({ children }) {
  return children;
}

export default DomainRouter;